export default "__VITE_ASSET__GAi$acIT__"